import React from 'react';
import { Target, Users, Globe, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-500 font-semibold text-sm uppercase tracking-wide">About Us</span>
          <h1 className="text-5xl font-bold text-gray-900 mt-2 mb-6">Forex Brokers Association</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading the way in establishing global standards for ethics and professionalism in the forex market
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Who We Are</h2>
          <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
            <p>
              The Forex Brokers Association (FBA) is a corporate membership organization dedicated to promoting 
              the highest standards of ethical conduct, transparency, and professionalism in the foreign exchange market.
            </p>
            <p>
              Founded with the mission to create a more robust, fair, and transparent forex marketplace, we bring 
              together leading brokers, financial institutions, and market participants from around the world. Our 
              members represent the best in the industry, committed to upholding the principles outlined in the 
              FX Global Code.
            </p>
            <p>
              Through continuous advocacy, education, and enforcement of ethical guidelines, we work to build trust 
              in the forex market and protect the interests of all participants – from individual traders to large 
              financial institutions.
            </p>
          </div>
        </div>

        {/* What We Do */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">What We Do</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                <Target className="text-white" size={28} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Set Standards</h3>
              <p className="text-gray-600">
                Establish and promote global best practices for ethical conduct in forex trading
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                <Users className="text-white" size={28} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Support Members</h3>
              <p className="text-gray-600">
                Provide resources, advocacy, and protection for our member organizations
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                <Globe className="text-white" size={28} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Global Reach</h3>
              <p className="text-gray-600">
                Connect market participants across 50+ countries worldwide
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="w-14 h-14 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                <TrendingUp className="text-white" size={28} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Drive Excellence</h3>
              <p className="text-gray-600">
                Recognize and celebrate outstanding achievements through our annual awards
              </p>
            </div>
          </div>
        </div>

        {/* Mission Statement */}
        <div className="bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl p-8 lg:p-12 text-white shadow-xl">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
            <p className="text-xl text-cyan-50 leading-relaxed mb-6">
              To promote integrity, transparency, and ethical practices in the foreign exchange market by 
              establishing global standards, supporting our members, and fostering a culture of professionalism 
              that benefits all market participants.
            </p>
            <p className="text-lg text-cyan-50 leading-relaxed">
              We believe that through collaboration, education, and unwavering commitment to ethical conduct, 
              we can create a forex marketplace that is fair, transparent, and trustworthy for everyone.
            </p>
          </div>
        </div>

        {/* Location */}
        <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Headquartered in New York</h3>
            <p className="text-gray-600 text-lg">
              Operating globally from the financial capital of the world, serving members across all continents
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;